module.exports = __webpack_public_path__ + "static/img/anB_1.621bd97.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/anB_1.png
// module id = 1257
// module chunks = 1